import { LogoutOptions, useAuth0 } from '@auth0/auth0-react';

// Hooks
import { useApp } from 'Shared/utils/hooks/use-app';

export const useSignOut = () => {
  const { logout } = useAuth0();
  const {
    app: {
      routes: { destroyUserSession },
    },
  } = useApp();

  const handleSignOut = () => {
    try {
      logout({
        logoutParams: {
          returnTo: window.origin + destroyUserSession,
        },
      } as LogoutOptions);
    } catch (e) {
      console.log(e);
    }
    window.location.href = destroyUserSession;
  };

  return {
    handleSignOut,
  };
};
